import { render, staticRenderFns } from "./inputSimpleInfo.vue?vue&type=template&id=3c1b252b&scoped=true&"
import script from "./inputSimpleInfo.vue?vue&type=script&lang=js&"
export * from "./inputSimpleInfo.vue?vue&type=script&lang=js&"
import style0 from "./inputSimpleInfo.vue?vue&type=style&index=0&id=3c1b252b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1b252b",
  null
  
)

export default component.exports